import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Logo from '../../assets/img/logo.svg';

const Header = ({ id }) => {
  const navScroll = () => {
    document.querySelector('.hero')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <section id={id} className='header' tabIndex={0}>
      <Row>
        <Col md={12} className='content'>
          <img onClick={navScroll} className='logo' src={Logo} alt='logo' />
        </Col>
      </Row>
    </section>
  );
};

export default Header;
